import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon, Loader, Table} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {warehouses} from '../../../../common/dictionaries/parameters';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import WarehouseDenialCauseModal from '../modals/warehouseDenialCause';
import './warehouseDenied.scss';

class WarehouseDenied extends Component {
  constructor(props) {
    super(props);

    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingScanning,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    const {agency} = this.props;
    this.props.fetchPickingWareHouseDeniedList(agency, {
      'warehouse': warehouses.main,
    });
  }

  onSubmit(formValues) {
    const {agency} = this.props;

    return this.props.saveReplacementPartWarehouseDenialCause(
      {
        'agency': agency.code,
        'dealer': agency.dealerIdentification,
      },
      formValues,
      {
        'warehouse': warehouses.main,
      }
    );
  }

  onBackButtonClick() {
    this.props.navigateBack();
  }

  renderSubtitle() {
    const {agency} = this.props;

    return (
      <Grid textAlign='left'>
        <Grid.Row>
          <Grid.Column width={2}>
            <h4>Concesionario:</h4>
          </Grid.Column>
          <Grid.Column width={4}>{agency.dealerName}</Grid.Column>
          <Grid.Column width={2}>
            <h4>Agencia:</h4>
          </Grid.Column>
          <Grid.Column width={4}>{agency.name}</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderReplacementPartCode(replacementPart) {
    const className =
      replacementPart.denialCauseCode && replacementPart.denialReason ?
        'green-color' :
        'red-color';

    return <span className={className}>{replacementPart.partCode}</span>;
  }

  renderWarehouseDenialCause(replacementPart) {
    if (replacementPart.denialCauseCode && replacementPart.denialReason) {
      return replacementPart.denialReason;
    }

    const {agency} = this.props;

    return (
      <WarehouseDenialCauseModal
        agency={agency}
        replacementPart={replacementPart}
        onSubmit={this.onSubmit}
        trigger={
          <span className='add-warehouse-denial-cause'>AGREGAR MOTIVO</span>
        }
      />
    );
  }

  renderPendingItems() {
    const {pickingWarehouseDeniedList} = this.props;

    return pickingWarehouseDeniedList.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            {this.renderReplacementPartCode(element)}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.pendingQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderWarehouseDenialCause(element)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderPendingItemsTableBody() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return this.renderPendingItems();
  }

  render() {
    return (
      <div className='scanning-warehouse-denied-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onBackButtonClick} />
              <h2 className='title-bar-text'>Warehouse Denied</h2>
              <div className='title-bar-actions'></div>
            </div>
            <div className='subtitle'>{this.renderSubtitle()}</div>
          </div>
        </Card>
        <Card fluid raised>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Descripción
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Motivo</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderPendingItemsTableBody()}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'agency': state.scanning.agencyData,
    'loading': state.scanning.loadingPickingWarehouseDeniedList,
    'pickingWarehouseDeniedList': state.scanning.pickingWarehouseDeniedList,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  fetchPickingWareHouseDeniedList,
  saveReplacementPartWarehouseDenialCause,
  navigateTo,
  navigateBack,
} = Actions;

export default connect(mapStateToProps, {
  fetchPickingWareHouseDeniedList,
  saveReplacementPartWarehouseDenialCause,
  navigateTo,
  navigateBack,
})(WarehouseDenied);
